// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./flaticon-1.ttf?4edcaa80cc3cba62a820b7d6fbfb9e36", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./flaticon-1.woff?4edcaa80cc3cba62a820b7d6fbfb9e36", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./flaticon-1.woff2?4edcaa80cc3cba62a820b7d6fbfb9e36", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./flaticon-1.eot?4edcaa80cc3cba62a820b7d6fbfb9e36", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./flaticon-1.svg?4edcaa80cc3cba62a820b7d6fbfb9e36", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___, { hash: "#flaticon" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: "flaticon";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype"),
url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff"),
url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"),
url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("embedded-opentype"),
url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("svg");
}

i[class^="flaticon-"]:before, i[class*=" flaticon-"]:before {
    font-family: flaticon !important;
    font-style: normal;
    font-weight: normal !important;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

.flaticon-dashboard:before {
    content: "\\f101";
}
.flaticon-dashboard-1:before {
    content: "\\f102";
}
.flaticon-more:before {
    content: "\\f103";
}
.flaticon-mobile-chat:before {
    content: "\\f104";
}
.flaticon-developer:before {
    content: "\\f105";
}
.flaticon-layout:before {
    content: "\\f106";
}
.flaticon-notification:before {
    content: "\\f107";
}
.flaticon-booking:before {
    content: "\\f108";
}
.flaticon-add:before {
    content: "\\f109";
}
.flaticon-app-development:before {
    content: "\\f10a";
}
.flaticon-add-1:before {
    content: "\\f10b";
}
.flaticon-application:before {
    content: "\\f10c";
}
.flaticon-app:before {
    content: "\\f10d";
}
.flaticon-coding:before {
    content: "\\f10e";
}
.flaticon-applications:before {
    content: "\\f10f";
}
.flaticon-business-report:before {
    content: "\\f110";
}
.flaticon-dashboard-2:before {
    content: "\\f111";
}
.flaticon-dashboard-3:before {
    content: "\\f112";
}
.flaticon-dashboard-interface:before {
    content: "\\f113";
}
.flaticon-dashboard-4:before {
    content: "\\f114";
}
.flaticon-bar-chart:before {
    content: "\\f115";
}
.flaticon-evolution:before {
    content: "\\f116";
}
.flaticon-pie-chart:before {
    content: "\\f117";
}
.flaticon-bar-chart-1:before {
    content: "\\f118";
}
.flaticon-pie-chart-1:before {
    content: "\\f119";
}
.flaticon-line-chart:before {
    content: "\\f11a";
}
.flaticon-charts:before {
    content: "\\f11b";
}
.flaticon-growth:before {
    content: "\\f11c";
}
.flaticon-arrow-chart:before {
    content: "\\f11d";
}
.flaticon-pie-chart-2:before {
    content: "\\f11e";
}
.flaticon-bootstrap:before {
    content: "\\f11f";
}
.flaticon-bootstrap-1:before {
    content: "\\f120";
}
.flaticon-web-plugin:before {
    content: "\\f121";
}
.flaticon-plugin:before {
    content: "\\f122";
}
.flaticon-web-plugin-1:before {
    content: "\\f123";
}
.flaticon-plugin-1:before {
    content: "\\f124";
}
.flaticon-plugin-2:before {
    content: "\\f125";
}
.flaticon-addon:before {
    content: "\\f126";
}
.flaticon-puzzle-piece:before {
    content: "\\f127";
}
.flaticon-plugin-3:before {
    content: "\\f128";
}
.flaticon-smartphone:before {
    content: "\\f129";
}
.flaticon-widget:before {
    content: "\\f12a";
}
.flaticon-mobile-app:before {
    content: "\\f12b";
}
.flaticon-squares:before {
    content: "\\f12c";
}
.flaticon-menu:before {
    content: "\\f12d";
}
.flaticon-menu-1:before {
    content: "\\f12e";
}
.flaticon-contact-form:before {
    content: "\\f12f";
}
.flaticon-sign-up:before {
    content: "\\f130";
}
.flaticon-google-forms:before {
    content: "\\f131";
}
.flaticon-clipboard:before {
    content: "\\f132";
}
.flaticon-online-registration:before {
    content: "\\f133";
}
.flaticon-list:before {
    content: "\\f134";
}
.flaticon-website:before {
    content: "\\f135";
}
.flaticon-checklist:before {
    content: "\\f136";
}
.flaticon-file:before {
    content: "\\f137";
}
.flaticon-contact-form-1:before {
    content: "\\f138";
}
.flaticon-check-list:before {
    content: "\\f139";
}
.flaticon-form:before {
    content: "\\f13a";
}
.flaticon-form-1:before {
    content: "\\f13b";
}
.flaticon-contact-form-2:before {
    content: "\\f13c";
}
.flaticon-registration-form:before {
    content: "\\f13d";
}
.flaticon-request:before {
    content: "\\f13e";
}
.flaticon-result:before {
    content: "\\f13f";
}
.flaticon-filling-form:before {
    content: "\\f140";
}
.flaticon-table:before {
    content: "\\f141";
}
.flaticon-menu-2:before {
    content: "\\f142";
}
.flaticon-table-1:before {
    content: "\\f143";
}
.flaticon-table-2:before {
    content: "\\f144";
}
.flaticon-landing-page:before {
    content: "\\f145";
}
.flaticon-web-page:before {
    content: "\\f146";
}
.flaticon-website-content:before {
    content: "\\f147";
}
.flaticon-landing-page-1:before {
    content: "\\f148";
}
.flaticon-browser:before {
    content: "\\f149";
}
.flaticon-landing-page-2:before {
    content: "\\f14a";
}
.flaticon-home-page:before {
    content: "\\f14b";
}
.flaticon-landing-page-3:before {
    content: "\\f14c";
}
.flaticon-website-1:before {
    content: "\\f14d";
}
.flaticon-website-design:before {
    content: "\\f14e";
}
.flaticon-web:before {
    content: "\\f14f";
}
.flaticon-browser-1:before {
    content: "\\f150";
}
.flaticon-landing-page-4:before {
    content: "\\f151";
}
.flaticon-home:before {
    content: "\\f152";
}
.flaticon-page:before {
    content: "\\f153";
}
.flaticon-user:before {
    content: "\\f154";
}
.flaticon-caret-arrow-up:before {
    content: "\\f155";
}
.flaticon-arrowhead-pointing-to-the-right:before {
    content: "\\f156";
}
.flaticon-arrow-up:before {
    content: "\\f157";
}
.flaticon-chevron:before {
    content: "\\f158";
}
.flaticon-chevron-1:before {
    content: "\\f159";
}
.flaticon-down-arrow:before {
    content: "\\f15a";
}
.flaticon-up-arrow:before {
    content: "\\f15b";
}
.flaticon-down-arrow-1:before {
    content: "\\f15c";
}
.flaticon-caret:before {
    content: "\\f15d";
}
.flaticon-up-arrow-angle:before {
    content: "\\f15e";
}
.flaticon-up-arrow-1:before {
    content: "\\f15f";
}
.flaticon-down-arrow-2:before {
    content: "\\f160";
}
.flaticon-right-arrow:before {
    content: "\\f161";
}
.flaticon-right-arrow-1:before {
    content: "\\f162";
}
.flaticon-arrow:before {
    content: "\\f163";
}
.flaticon-right:before {
    content: "\\f164";
}
.flaticon-left-arrow:before {
    content: "\\f165";
}
.flaticon-share:before {
    content: "\\f166";
}
.flaticon-arrow-1:before {
    content: "\\f167";
}
.flaticon-exchange:before {
    content: "\\f168";
}
.flaticon-up-arrow-2:before {
    content: "\\f169";
}
.flaticon-rewind:before {
    content: "\\f16a";
}
.flaticon-fast-forward:before {
    content: "\\f16b";
}
.flaticon-skip:before {
    content: "\\f16c";
}
.flaticon-bell:before {
    content: "\\f16d";
}
.flaticon-bell-1:before {
    content: "\\f16e";
}
.flaticon-notification-1:before {
    content: "\\f16f";
}
.flaticon-notification-2:before {
    content: "\\f170";
}
.flaticon-email:before {
    content: "\\f171";
}
.flaticon-email-1:before {
    content: "\\f172";
}
.flaticon-message:before {
    content: "\\f173";
}
.flaticon-messenger:before {
    content: "\\f174";
}
.flaticon-chat:before {
    content: "\\f175";
}
.flaticon-comment:before {
    content: "\\f176";
}
.flaticon-chatting:before {
    content: "\\f177";
}
.flaticon-message-1:before {
    content: "\\f178";
}
.flaticon-chat-1:before {
    content: "\\f179";
}
.flaticon-message-2:before {
    content: "\\f17a";
}
.flaticon-customer-support:before {
    content: "\\f17b";
}
.flaticon-message-3:before {
    content: "\\f17c";
}
.flaticon-mail:before {
    content: "\\f17d";
}
.flaticon-chat-2:before {
    content: "\\f17e";
}
.flaticon-chat-3:before {
    content: "\\f17f";
}
.flaticon-message-4:before {
    content: "\\f180";
}
.flaticon-mail-1:before {
    content: "\\f181";
}
.flaticon-messages:before {
    content: "\\f182";
}
.flaticon-messages-1:before {
    content: "\\f183";
}
.flaticon-chat-box:before {
    content: "\\f184";
}
.flaticon-mail-2:before {
    content: "\\f185";
}
.flaticon-mail-3:before {
    content: "\\f186";
}
.flaticon-mail-4:before {
    content: "\\f187";
}
.flaticon-email-2:before {
    content: "\\f188";
}
.flaticon-email-3:before {
    content: "\\f189";
}
.flaticon-email-4:before {
    content: "\\f18a";
}
.flaticon-phone-call:before {
    content: "\\f18b";
}
.flaticon-call:before {
    content: "\\f18c";
}
.flaticon-call-1:before {
    content: "\\f18d";
}
.flaticon-calling:before {
    content: "\\f18e";
}
.flaticon-phone-call-1:before {
    content: "\\f18f";
}
.flaticon-phone-call-2:before {
    content: "\\f190";
}
.flaticon-lighting:before {
    content: "\\f191";
}
.flaticon-electric:before {
    content: "\\f192";
}
.flaticon-battery:before {
    content: "\\f193";
}
.flaticon-calendar:before {
    content: "\\f194";
}
.flaticon-calendar-1:before {
    content: "\\f195";
}
.flaticon-calendar-2:before {
    content: "\\f196";
}
.flaticon-calendar-3:before {
    content: "\\f197";
}
.flaticon-calendar-4:before {
    content: "\\f198";
}
.flaticon-calendar-5:before {
    content: "\\f199";
}
.flaticon-calendar-6:before {
    content: "\\f19a";
}
.flaticon-calendar-7:before {
    content: "\\f19b";
}
.flaticon-user-1:before {
    content: "\\f19c";
}
.flaticon-user-2:before {
    content: "\\f19d";
}
.flaticon-user-3:before {
    content: "\\f19e";
}
.flaticon-user-4:before {
    content: "\\f19f";
}
.flaticon-account:before {
    content: "\\f1a0";
}
.flaticon-user-5:before {
    content: "\\f1a1";
}
.flaticon-logout:before {
    content: "\\f1a2";
}
.flaticon-logout-1:before {
    content: "\\f1a3";
}
.flaticon-logout-2:before {
    content: "\\f1a4";
}
.flaticon-logout-3:before {
    content: "\\f1a5";
}
.flaticon-logout-4:before {
    content: "\\f1a6";
}
.flaticon-clock:before {
    content: "\\f1a7";
}
.flaticon-clock-1:before {
    content: "\\f1a8";
}
.flaticon-clock-2:before {
    content: "\\f1a9";
}
.flaticon-wall-clock:before {
    content: "\\f1aa";
}
.flaticon-clock-3:before {
    content: "\\f1ab";
}
.flaticon-check:before {
    content: "\\f1ac";
}
.flaticon-check-1:before {
    content: "\\f1ad";
}
.flaticon-checked:before {
    content: "\\f1ae";
}
.flaticon-check-2:before {
    content: "\\f1af";
}
.flaticon-check-mark:before {
    content: "\\f1b0";
}
.flaticon-accept:before {
    content: "\\f1b1";
}
.flaticon-check-3:before {
    content: "\\f1b2";
}
.flaticon-check-4:before {
    content: "\\f1b3";
}
.flaticon-check-5:before {
    content: "\\f1b4";
}
.flaticon-checking-box-with-a-checkmark:before {
    content: "\\f1b5";
}
.flaticon-location:before {
    content: "\\f1b6";
}
.flaticon-location-1:before {
    content: "\\f1b7";
}
.flaticon-forward:before {
    content: "\\f1b8";
}
.flaticon-arrow-2:before {
    content: "\\f1b9";
}
.flaticon-forward-1:before {
    content: "\\f1ba";
}
.flaticon-forward-2:before {
    content: "\\f1bb";
}
.flaticon-reply:before {
    content: "\\f1bc";
}
.flaticon-reply-1:before {
    content: "\\f1bd";
}
.flaticon-reply-2:before {
    content: "\\f1be";
}
.flaticon-reply-3:before {
    content: "\\f1bf";
}
.flaticon-camera:before {
    content: "\\f1c0";
}
.flaticon-camera-1:before {
    content: "\\f1c1";
}
.flaticon-like:before {
    content: "\\f1c2";
}
.flaticon-like-1:before {
    content: "\\f1c3";
}
.flaticon-love:before {
    content: "\\f1c4";
}
.flaticon-heart:before {
    content: "\\f1c5";
}
.flaticon-like-2:before {
    content: "\\f1c6";
}
.flaticon-heart-1:before {
    content: "\\f1c7";
}
.flaticon-send:before {
    content: "\\f1c8";
}
.flaticon-send-1:before {
    content: "\\f1c9";
}
.flaticon-send-2:before {
    content: "\\f1ca";
}
.flaticon-send-3:before {
    content: "\\f1cb";
}
.flaticon-paper-plane:before {
    content: "\\f1cc";
}
.flaticon-exclamation:before {
    content: "\\f1cd";
}
.flaticon-danger:before {
    content: "\\f1ce";
}
.flaticon-message-5:before {
    content: "\\f1cf";
}
.flaticon-clipboard-1:before {
    content: "\\f1d0";
}
.flaticon-exclamation-mark:before {
    content: "\\f1d1";
}
.flaticon-draft:before {
    content: "\\f1d2";
}
.flaticon-draft-1:before {
    content: "\\f1d3";
}
.flaticon-notes:before {
    content: "\\f1d4";
}
.flaticon-delete:before {
    content: "\\f1d5";
}
.flaticon-bin:before {
    content: "\\f1d6";
}
.flaticon-plus:before {
    content: "\\f1d7";
}
.flaticon-plus-1:before {
    content: "\\f1d8";
}
.flaticon-plus-2:before {
    content: "\\f1d9";
}
.flaticon-plus-3:before {
    content: "\\f1da";
}
.flaticon-plus-4:before {
    content: "\\f1db";
}
.flaticon-plus-sign:before {
    content: "\\f1dc";
}
.flaticon-star:before {
    content: "\\f1dd";
}
.flaticon-star-1:before {
    content: "\\f1de";
}
.flaticon-facebook:before {
    content: "\\f1df";
}
.flaticon-facebook-1:before {
    content: "\\f1e0";
}
.flaticon-facebook-2:before {
    content: "\\f1e1";
}
.flaticon-twitter:before {
    content: "\\f1e2";
}
.flaticon-twitter-1:before {
    content: "\\f1e3";
}
.flaticon-twitter-2:before {
    content: "\\f1e4";
}
.flaticon-linkedin:before {
    content: "\\f1e5";
}
.flaticon-linkedin-1:before {
    content: "\\f1e6";
}
.flaticon-plus-5:before {
    content: "\\f1e7";
}
.flaticon-google-plus:before {
    content: "\\f1e8";
}
.flaticon-youtube:before {
    content: "\\f1e9";
}
.flaticon-youtube-1:before {
    content: "\\f1ea";
}
.flaticon-youtube-2:before {
    content: "\\f1eb";
}
.flaticon-instagram:before {
    content: "\\f1ec";
}
.flaticon-instagram-1:before {
    content: "\\f1ed";
}
.flaticon-pinterest:before {
    content: "\\f1ee";
}
.flaticon-pinterest-1:before {
    content: "\\f1ef";
}
.flaticon-google-glass-logo:before {
    content: "\\f1f0";
}
.flaticon-snapchat:before {
    content: "\\f1f1";
}
.flaticon-snapchat-1:before {
    content: "\\f1f2";
}
.flaticon-whatsapp:before {
    content: "\\f1f3";
}
.flaticon-whatsapp-1:before {
    content: "\\f1f4";
}
.flaticon-whatsapp-2:before {
    content: "\\f1f5";
}
`, "",{"version":3,"sources":["webpack://./src/icons/flaticon-1/font/flaticon-1.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB;;;;qDAI2E;AAC/E;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;IAClB,8BAA8B;IAC9B,oBAAoB;IACpB,oBAAoB;IACpB,cAAc;IACd,mCAAmC;IACnC,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB","sourcesContent":["@font-face {\n    font-family: \"flaticon\";\n    src: url(\"./flaticon-1.ttf?4edcaa80cc3cba62a820b7d6fbfb9e36\") format(\"truetype\"),\nurl(\"./flaticon-1.woff?4edcaa80cc3cba62a820b7d6fbfb9e36\") format(\"woff\"),\nurl(\"./flaticon-1.woff2?4edcaa80cc3cba62a820b7d6fbfb9e36\") format(\"woff2\"),\nurl(\"./flaticon-1.eot?4edcaa80cc3cba62a820b7d6fbfb9e36#iefix\") format(\"embedded-opentype\"),\nurl(\"./flaticon-1.svg?4edcaa80cc3cba62a820b7d6fbfb9e36#flaticon\") format(\"svg\");\n}\n\ni[class^=\"flaticon-\"]:before, i[class*=\" flaticon-\"]:before {\n    font-family: flaticon !important;\n    font-style: normal;\n    font-weight: normal !important;\n    font-variant: normal;\n    text-transform: none;\n    line-height: 1;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n.flaticon-dashboard:before {\n    content: \"\\f101\";\n}\n.flaticon-dashboard-1:before {\n    content: \"\\f102\";\n}\n.flaticon-more:before {\n    content: \"\\f103\";\n}\n.flaticon-mobile-chat:before {\n    content: \"\\f104\";\n}\n.flaticon-developer:before {\n    content: \"\\f105\";\n}\n.flaticon-layout:before {\n    content: \"\\f106\";\n}\n.flaticon-notification:before {\n    content: \"\\f107\";\n}\n.flaticon-booking:before {\n    content: \"\\f108\";\n}\n.flaticon-add:before {\n    content: \"\\f109\";\n}\n.flaticon-app-development:before {\n    content: \"\\f10a\";\n}\n.flaticon-add-1:before {\n    content: \"\\f10b\";\n}\n.flaticon-application:before {\n    content: \"\\f10c\";\n}\n.flaticon-app:before {\n    content: \"\\f10d\";\n}\n.flaticon-coding:before {\n    content: \"\\f10e\";\n}\n.flaticon-applications:before {\n    content: \"\\f10f\";\n}\n.flaticon-business-report:before {\n    content: \"\\f110\";\n}\n.flaticon-dashboard-2:before {\n    content: \"\\f111\";\n}\n.flaticon-dashboard-3:before {\n    content: \"\\f112\";\n}\n.flaticon-dashboard-interface:before {\n    content: \"\\f113\";\n}\n.flaticon-dashboard-4:before {\n    content: \"\\f114\";\n}\n.flaticon-bar-chart:before {\n    content: \"\\f115\";\n}\n.flaticon-evolution:before {\n    content: \"\\f116\";\n}\n.flaticon-pie-chart:before {\n    content: \"\\f117\";\n}\n.flaticon-bar-chart-1:before {\n    content: \"\\f118\";\n}\n.flaticon-pie-chart-1:before {\n    content: \"\\f119\";\n}\n.flaticon-line-chart:before {\n    content: \"\\f11a\";\n}\n.flaticon-charts:before {\n    content: \"\\f11b\";\n}\n.flaticon-growth:before {\n    content: \"\\f11c\";\n}\n.flaticon-arrow-chart:before {\n    content: \"\\f11d\";\n}\n.flaticon-pie-chart-2:before {\n    content: \"\\f11e\";\n}\n.flaticon-bootstrap:before {\n    content: \"\\f11f\";\n}\n.flaticon-bootstrap-1:before {\n    content: \"\\f120\";\n}\n.flaticon-web-plugin:before {\n    content: \"\\f121\";\n}\n.flaticon-plugin:before {\n    content: \"\\f122\";\n}\n.flaticon-web-plugin-1:before {\n    content: \"\\f123\";\n}\n.flaticon-plugin-1:before {\n    content: \"\\f124\";\n}\n.flaticon-plugin-2:before {\n    content: \"\\f125\";\n}\n.flaticon-addon:before {\n    content: \"\\f126\";\n}\n.flaticon-puzzle-piece:before {\n    content: \"\\f127\";\n}\n.flaticon-plugin-3:before {\n    content: \"\\f128\";\n}\n.flaticon-smartphone:before {\n    content: \"\\f129\";\n}\n.flaticon-widget:before {\n    content: \"\\f12a\";\n}\n.flaticon-mobile-app:before {\n    content: \"\\f12b\";\n}\n.flaticon-squares:before {\n    content: \"\\f12c\";\n}\n.flaticon-menu:before {\n    content: \"\\f12d\";\n}\n.flaticon-menu-1:before {\n    content: \"\\f12e\";\n}\n.flaticon-contact-form:before {\n    content: \"\\f12f\";\n}\n.flaticon-sign-up:before {\n    content: \"\\f130\";\n}\n.flaticon-google-forms:before {\n    content: \"\\f131\";\n}\n.flaticon-clipboard:before {\n    content: \"\\f132\";\n}\n.flaticon-online-registration:before {\n    content: \"\\f133\";\n}\n.flaticon-list:before {\n    content: \"\\f134\";\n}\n.flaticon-website:before {\n    content: \"\\f135\";\n}\n.flaticon-checklist:before {\n    content: \"\\f136\";\n}\n.flaticon-file:before {\n    content: \"\\f137\";\n}\n.flaticon-contact-form-1:before {\n    content: \"\\f138\";\n}\n.flaticon-check-list:before {\n    content: \"\\f139\";\n}\n.flaticon-form:before {\n    content: \"\\f13a\";\n}\n.flaticon-form-1:before {\n    content: \"\\f13b\";\n}\n.flaticon-contact-form-2:before {\n    content: \"\\f13c\";\n}\n.flaticon-registration-form:before {\n    content: \"\\f13d\";\n}\n.flaticon-request:before {\n    content: \"\\f13e\";\n}\n.flaticon-result:before {\n    content: \"\\f13f\";\n}\n.flaticon-filling-form:before {\n    content: \"\\f140\";\n}\n.flaticon-table:before {\n    content: \"\\f141\";\n}\n.flaticon-menu-2:before {\n    content: \"\\f142\";\n}\n.flaticon-table-1:before {\n    content: \"\\f143\";\n}\n.flaticon-table-2:before {\n    content: \"\\f144\";\n}\n.flaticon-landing-page:before {\n    content: \"\\f145\";\n}\n.flaticon-web-page:before {\n    content: \"\\f146\";\n}\n.flaticon-website-content:before {\n    content: \"\\f147\";\n}\n.flaticon-landing-page-1:before {\n    content: \"\\f148\";\n}\n.flaticon-browser:before {\n    content: \"\\f149\";\n}\n.flaticon-landing-page-2:before {\n    content: \"\\f14a\";\n}\n.flaticon-home-page:before {\n    content: \"\\f14b\";\n}\n.flaticon-landing-page-3:before {\n    content: \"\\f14c\";\n}\n.flaticon-website-1:before {\n    content: \"\\f14d\";\n}\n.flaticon-website-design:before {\n    content: \"\\f14e\";\n}\n.flaticon-web:before {\n    content: \"\\f14f\";\n}\n.flaticon-browser-1:before {\n    content: \"\\f150\";\n}\n.flaticon-landing-page-4:before {\n    content: \"\\f151\";\n}\n.flaticon-home:before {\n    content: \"\\f152\";\n}\n.flaticon-page:before {\n    content: \"\\f153\";\n}\n.flaticon-user:before {\n    content: \"\\f154\";\n}\n.flaticon-caret-arrow-up:before {\n    content: \"\\f155\";\n}\n.flaticon-arrowhead-pointing-to-the-right:before {\n    content: \"\\f156\";\n}\n.flaticon-arrow-up:before {\n    content: \"\\f157\";\n}\n.flaticon-chevron:before {\n    content: \"\\f158\";\n}\n.flaticon-chevron-1:before {\n    content: \"\\f159\";\n}\n.flaticon-down-arrow:before {\n    content: \"\\f15a\";\n}\n.flaticon-up-arrow:before {\n    content: \"\\f15b\";\n}\n.flaticon-down-arrow-1:before {\n    content: \"\\f15c\";\n}\n.flaticon-caret:before {\n    content: \"\\f15d\";\n}\n.flaticon-up-arrow-angle:before {\n    content: \"\\f15e\";\n}\n.flaticon-up-arrow-1:before {\n    content: \"\\f15f\";\n}\n.flaticon-down-arrow-2:before {\n    content: \"\\f160\";\n}\n.flaticon-right-arrow:before {\n    content: \"\\f161\";\n}\n.flaticon-right-arrow-1:before {\n    content: \"\\f162\";\n}\n.flaticon-arrow:before {\n    content: \"\\f163\";\n}\n.flaticon-right:before {\n    content: \"\\f164\";\n}\n.flaticon-left-arrow:before {\n    content: \"\\f165\";\n}\n.flaticon-share:before {\n    content: \"\\f166\";\n}\n.flaticon-arrow-1:before {\n    content: \"\\f167\";\n}\n.flaticon-exchange:before {\n    content: \"\\f168\";\n}\n.flaticon-up-arrow-2:before {\n    content: \"\\f169\";\n}\n.flaticon-rewind:before {\n    content: \"\\f16a\";\n}\n.flaticon-fast-forward:before {\n    content: \"\\f16b\";\n}\n.flaticon-skip:before {\n    content: \"\\f16c\";\n}\n.flaticon-bell:before {\n    content: \"\\f16d\";\n}\n.flaticon-bell-1:before {\n    content: \"\\f16e\";\n}\n.flaticon-notification-1:before {\n    content: \"\\f16f\";\n}\n.flaticon-notification-2:before {\n    content: \"\\f170\";\n}\n.flaticon-email:before {\n    content: \"\\f171\";\n}\n.flaticon-email-1:before {\n    content: \"\\f172\";\n}\n.flaticon-message:before {\n    content: \"\\f173\";\n}\n.flaticon-messenger:before {\n    content: \"\\f174\";\n}\n.flaticon-chat:before {\n    content: \"\\f175\";\n}\n.flaticon-comment:before {\n    content: \"\\f176\";\n}\n.flaticon-chatting:before {\n    content: \"\\f177\";\n}\n.flaticon-message-1:before {\n    content: \"\\f178\";\n}\n.flaticon-chat-1:before {\n    content: \"\\f179\";\n}\n.flaticon-message-2:before {\n    content: \"\\f17a\";\n}\n.flaticon-customer-support:before {\n    content: \"\\f17b\";\n}\n.flaticon-message-3:before {\n    content: \"\\f17c\";\n}\n.flaticon-mail:before {\n    content: \"\\f17d\";\n}\n.flaticon-chat-2:before {\n    content: \"\\f17e\";\n}\n.flaticon-chat-3:before {\n    content: \"\\f17f\";\n}\n.flaticon-message-4:before {\n    content: \"\\f180\";\n}\n.flaticon-mail-1:before {\n    content: \"\\f181\";\n}\n.flaticon-messages:before {\n    content: \"\\f182\";\n}\n.flaticon-messages-1:before {\n    content: \"\\f183\";\n}\n.flaticon-chat-box:before {\n    content: \"\\f184\";\n}\n.flaticon-mail-2:before {\n    content: \"\\f185\";\n}\n.flaticon-mail-3:before {\n    content: \"\\f186\";\n}\n.flaticon-mail-4:before {\n    content: \"\\f187\";\n}\n.flaticon-email-2:before {\n    content: \"\\f188\";\n}\n.flaticon-email-3:before {\n    content: \"\\f189\";\n}\n.flaticon-email-4:before {\n    content: \"\\f18a\";\n}\n.flaticon-phone-call:before {\n    content: \"\\f18b\";\n}\n.flaticon-call:before {\n    content: \"\\f18c\";\n}\n.flaticon-call-1:before {\n    content: \"\\f18d\";\n}\n.flaticon-calling:before {\n    content: \"\\f18e\";\n}\n.flaticon-phone-call-1:before {\n    content: \"\\f18f\";\n}\n.flaticon-phone-call-2:before {\n    content: \"\\f190\";\n}\n.flaticon-lighting:before {\n    content: \"\\f191\";\n}\n.flaticon-electric:before {\n    content: \"\\f192\";\n}\n.flaticon-battery:before {\n    content: \"\\f193\";\n}\n.flaticon-calendar:before {\n    content: \"\\f194\";\n}\n.flaticon-calendar-1:before {\n    content: \"\\f195\";\n}\n.flaticon-calendar-2:before {\n    content: \"\\f196\";\n}\n.flaticon-calendar-3:before {\n    content: \"\\f197\";\n}\n.flaticon-calendar-4:before {\n    content: \"\\f198\";\n}\n.flaticon-calendar-5:before {\n    content: \"\\f199\";\n}\n.flaticon-calendar-6:before {\n    content: \"\\f19a\";\n}\n.flaticon-calendar-7:before {\n    content: \"\\f19b\";\n}\n.flaticon-user-1:before {\n    content: \"\\f19c\";\n}\n.flaticon-user-2:before {\n    content: \"\\f19d\";\n}\n.flaticon-user-3:before {\n    content: \"\\f19e\";\n}\n.flaticon-user-4:before {\n    content: \"\\f19f\";\n}\n.flaticon-account:before {\n    content: \"\\f1a0\";\n}\n.flaticon-user-5:before {\n    content: \"\\f1a1\";\n}\n.flaticon-logout:before {\n    content: \"\\f1a2\";\n}\n.flaticon-logout-1:before {\n    content: \"\\f1a3\";\n}\n.flaticon-logout-2:before {\n    content: \"\\f1a4\";\n}\n.flaticon-logout-3:before {\n    content: \"\\f1a5\";\n}\n.flaticon-logout-4:before {\n    content: \"\\f1a6\";\n}\n.flaticon-clock:before {\n    content: \"\\f1a7\";\n}\n.flaticon-clock-1:before {\n    content: \"\\f1a8\";\n}\n.flaticon-clock-2:before {\n    content: \"\\f1a9\";\n}\n.flaticon-wall-clock:before {\n    content: \"\\f1aa\";\n}\n.flaticon-clock-3:before {\n    content: \"\\f1ab\";\n}\n.flaticon-check:before {\n    content: \"\\f1ac\";\n}\n.flaticon-check-1:before {\n    content: \"\\f1ad\";\n}\n.flaticon-checked:before {\n    content: \"\\f1ae\";\n}\n.flaticon-check-2:before {\n    content: \"\\f1af\";\n}\n.flaticon-check-mark:before {\n    content: \"\\f1b0\";\n}\n.flaticon-accept:before {\n    content: \"\\f1b1\";\n}\n.flaticon-check-3:before {\n    content: \"\\f1b2\";\n}\n.flaticon-check-4:before {\n    content: \"\\f1b3\";\n}\n.flaticon-check-5:before {\n    content: \"\\f1b4\";\n}\n.flaticon-checking-box-with-a-checkmark:before {\n    content: \"\\f1b5\";\n}\n.flaticon-location:before {\n    content: \"\\f1b6\";\n}\n.flaticon-location-1:before {\n    content: \"\\f1b7\";\n}\n.flaticon-forward:before {\n    content: \"\\f1b8\";\n}\n.flaticon-arrow-2:before {\n    content: \"\\f1b9\";\n}\n.flaticon-forward-1:before {\n    content: \"\\f1ba\";\n}\n.flaticon-forward-2:before {\n    content: \"\\f1bb\";\n}\n.flaticon-reply:before {\n    content: \"\\f1bc\";\n}\n.flaticon-reply-1:before {\n    content: \"\\f1bd\";\n}\n.flaticon-reply-2:before {\n    content: \"\\f1be\";\n}\n.flaticon-reply-3:before {\n    content: \"\\f1bf\";\n}\n.flaticon-camera:before {\n    content: \"\\f1c0\";\n}\n.flaticon-camera-1:before {\n    content: \"\\f1c1\";\n}\n.flaticon-like:before {\n    content: \"\\f1c2\";\n}\n.flaticon-like-1:before {\n    content: \"\\f1c3\";\n}\n.flaticon-love:before {\n    content: \"\\f1c4\";\n}\n.flaticon-heart:before {\n    content: \"\\f1c5\";\n}\n.flaticon-like-2:before {\n    content: \"\\f1c6\";\n}\n.flaticon-heart-1:before {\n    content: \"\\f1c7\";\n}\n.flaticon-send:before {\n    content: \"\\f1c8\";\n}\n.flaticon-send-1:before {\n    content: \"\\f1c9\";\n}\n.flaticon-send-2:before {\n    content: \"\\f1ca\";\n}\n.flaticon-send-3:before {\n    content: \"\\f1cb\";\n}\n.flaticon-paper-plane:before {\n    content: \"\\f1cc\";\n}\n.flaticon-exclamation:before {\n    content: \"\\f1cd\";\n}\n.flaticon-danger:before {\n    content: \"\\f1ce\";\n}\n.flaticon-message-5:before {\n    content: \"\\f1cf\";\n}\n.flaticon-clipboard-1:before {\n    content: \"\\f1d0\";\n}\n.flaticon-exclamation-mark:before {\n    content: \"\\f1d1\";\n}\n.flaticon-draft:before {\n    content: \"\\f1d2\";\n}\n.flaticon-draft-1:before {\n    content: \"\\f1d3\";\n}\n.flaticon-notes:before {\n    content: \"\\f1d4\";\n}\n.flaticon-delete:before {\n    content: \"\\f1d5\";\n}\n.flaticon-bin:before {\n    content: \"\\f1d6\";\n}\n.flaticon-plus:before {\n    content: \"\\f1d7\";\n}\n.flaticon-plus-1:before {\n    content: \"\\f1d8\";\n}\n.flaticon-plus-2:before {\n    content: \"\\f1d9\";\n}\n.flaticon-plus-3:before {\n    content: \"\\f1da\";\n}\n.flaticon-plus-4:before {\n    content: \"\\f1db\";\n}\n.flaticon-plus-sign:before {\n    content: \"\\f1dc\";\n}\n.flaticon-star:before {\n    content: \"\\f1dd\";\n}\n.flaticon-star-1:before {\n    content: \"\\f1de\";\n}\n.flaticon-facebook:before {\n    content: \"\\f1df\";\n}\n.flaticon-facebook-1:before {\n    content: \"\\f1e0\";\n}\n.flaticon-facebook-2:before {\n    content: \"\\f1e1\";\n}\n.flaticon-twitter:before {\n    content: \"\\f1e2\";\n}\n.flaticon-twitter-1:before {\n    content: \"\\f1e3\";\n}\n.flaticon-twitter-2:before {\n    content: \"\\f1e4\";\n}\n.flaticon-linkedin:before {\n    content: \"\\f1e5\";\n}\n.flaticon-linkedin-1:before {\n    content: \"\\f1e6\";\n}\n.flaticon-plus-5:before {\n    content: \"\\f1e7\";\n}\n.flaticon-google-plus:before {\n    content: \"\\f1e8\";\n}\n.flaticon-youtube:before {\n    content: \"\\f1e9\";\n}\n.flaticon-youtube-1:before {\n    content: \"\\f1ea\";\n}\n.flaticon-youtube-2:before {\n    content: \"\\f1eb\";\n}\n.flaticon-instagram:before {\n    content: \"\\f1ec\";\n}\n.flaticon-instagram-1:before {\n    content: \"\\f1ed\";\n}\n.flaticon-pinterest:before {\n    content: \"\\f1ee\";\n}\n.flaticon-pinterest-1:before {\n    content: \"\\f1ef\";\n}\n.flaticon-google-glass-logo:before {\n    content: \"\\f1f0\";\n}\n.flaticon-snapchat:before {\n    content: \"\\f1f1\";\n}\n.flaticon-snapchat-1:before {\n    content: \"\\f1f2\";\n}\n.flaticon-whatsapp:before {\n    content: \"\\f1f3\";\n}\n.flaticon-whatsapp-1:before {\n    content: \"\\f1f4\";\n}\n.flaticon-whatsapp-2:before {\n    content: \"\\f1f5\";\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
